import {connect} from 'react-redux'
import {selectActiveExplanation} from '../../../redux/modules/topic'
import {wrapDispatch} from 'multireducer'
import {selectUserInfo} from '../../../redux/modules/session'
import {showToast} from '../../../redux/modules/toast'
import {toJS} from '../../../util/ToJS'
import LeafInteractiveContent from '../components/LeafInteractiveContent'
import {showModal} from '../../../redux/modules/modal'
import {postToggleVote} from '../../../redux/modules/content'
import {handleNewContent} from '../../../redux/modules/topic'
import qs from 'query-string'

// Compress this code to simpler format and check if ownProps are already passed
const mapStateToProps = (state, ownProps) => {
  const userInfo = selectUserInfo(state)
  const isModerator = (userInfo.role === 'mod' || userInfo.role === 'admin')
  return ({
    ...selectActiveExplanation(state, ownProps.as),
    collapsible: true,
    topicId: ownProps.topicId,
    isLoggedIn: userInfo.isLoggedIn,
    isModerator: isModerator,
  })
}

const mapDispatchToProps = (dispatch, {topicId, as}) => ({
  openEditor: (contentId, type) => {
    dispatch(showModal('CONTENT_EDITOR',{
      contentOrTopicId: contentId,
      topicId: topicId,
      createOrEdit: 'edit',
      contentType: type,
      handleNewContent: (newContent) => {
        dispatch(handleNewContent(topicId, newContent))
      }
    }))
  },
  showRegister: (followup) => dispatch(showModal('REGISTER', {followup})),
  openShare: (contentId, type) => {
    const query = qs.stringify({type: type, id:contentId})
    const slug = `${window.location.origin}${window.location.pathname}?${query}`

    dispatch(showModal('SHARE',{
      type: type,
      slug: slug
    }))
  },
  openReport: (item) => {
    dispatch(showModal('REPORT',{
      item: item,
    }))
  },
  errorToast: () => {
    dispatch(showToast({
      'text': 'This content could not be found.',
      'timeout': 5000
    }))
  },
  toggleVote: (type, id) => {
    wrapDispatch(dispatch, as)(postToggleVote(type,id))
  }
})

const VisibleLeafExplanationContent = connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(LeafInteractiveContent))

export default VisibleLeafExplanationContent



// WEBPACK FOOTER //
// ./src/domains/topic/containers/VisibleLeafExplanationContent.js